import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";

const NotificationsPage = () => {
    const navigate = useNavigate();

    // Using an object to manage all checkbox states
    const [notifications, setNotifications] = useState({
        muteNotifications: false,
        weeklySummary: false,
        subscribeToSurveys: false
    });

    // Generic handler for all checkboxes
    const handleCheckboxChange = (key) => {
        setNotifications(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    return (
        <div className="min-h-screen bg-white dark:bg-[#1E1D21] dark:text-white">
            <div className="sticky top-0 z-50">
                <div className="relative flex items-center justify-center h-14 bg-[#BDE6FF] rounded-b-2xl px-3">
                    <IoMdArrowBack
                        onClick={() => navigate(-1)}
                        className="absolute left-3 top-1/2 -translate-y-1/2 text-[22px] text-black cursor-pointer"
                    />
                    <p className="text-center font-bold text-[16px] text-black">Notifications</p>
                </div>
            </div>

            <div className="px-3 py-3">
                <div className="rounded-2xl border-2 border-[#BDE6FF] dark:border-gray-800/50 bg-white p-3 text-[12px] font-normal text-[#222] dark:bg-[#333333] dark:text-white">
                    Keep track of what’s happening in your Chaa Chingg via email alerts, on-site
                    notifications, or a combination of the two.
                </div>

                <div className="mt-4 rounded-2xl border-2 border-[#BDE6FF] dark:border-gray-800/50 bg-white dark:bg-[#333333]">
                    <div className="border-b-2 border-[#BDE6FF] dark:border-gray-800/50 p-3">
                        <h2 className="text-[14px] font-bold text-black dark:text-white">In App Notifications</h2>
                        <p className="mt-2 text-[12px] font-normal text-[#444] dark:text-white/80">
                            You will always get alerted with notifications about account and post
                            interactions, messages, mentions, and more. To access your notifications,
                            click on the notification icon at the top of your account profile page.
                            You can also choose to mute notifications from here.
                        </p>
                    </div>

                    <div className="border-b-2 border-[#BDE6FF] dark:border-gray-800/50">
                        <div className="flex items-center justify-between p-3">
                            <h2 className="text-[14px] font-bold text-black dark:text-white">Mute Notifications</h2>
                            <label className="autoSaverSwitch relative inline-flex cursor-pointer select-none items-center">
                                <input
                                    type="checkbox"
                                    name="muteNotifications"
                                    className="sr-only"
                                    checked={notifications.muteNotifications}
                                    onChange={() => handleCheckboxChange("muteNotifications")}
                                />
                                <span className={`slider flex h-[19px] w-[40px] items-center rounded-full p-1 duration-200 ${notifications.muteNotifications ? "bg-[#BDE6FF]" : "bg-[#d9d9d9]"}`}>
                                    <span className={`dot h-[13px] w-[13px] rounded-full bg-[#666666] shadow-2xl duration-200 ${notifications.muteNotifications ? "translate-x-5" : ""}`} />
                                </span>
                            </label>
                        </div>
                    </div>

                    <div className="p-3">
                        <h2 className="text-[14px] font-bold text-black dark:text-white">Email Alerts</h2>
                        <div className="mt-1 flex items-center justify-between">
                            <p className="text-[12px] font-medium text-[#444] dark:text-white/80">Subscribe to survey emails</p>
                            <label className="autoSaverSwitch relative inline-flex cursor-pointer select-none items-center">
                                <input
                                    type="checkbox"
                                    name="subscribeToSurveys"
                                    className="sr-only"
                                    checked={notifications.subscribeToSurveys}
                                    onChange={() => handleCheckboxChange("subscribeToSurveys")}
                                />
                                <span className={`slider flex h-[19px] w-[40px] items-center rounded-full p-1 duration-200 ${notifications.subscribeToSurveys ? "bg-[#BDE6FF]" : "bg-[#d9d9d9]"}`}>
                                    <span className={`dot h-[13px] w-[13px] rounded-full bg-[#666666] shadow-2xl duration-200 ${notifications.subscribeToSurveys ? "translate-x-5" : ""}`} />
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotificationsPage